import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { add2, addN2, max2, normalCW, set2, sub2, ZERO2, } from "@thi.ng/vectors";
import { Circle } from "../api/circle";
import { Quad } from "../api/quad";
import { rectFromCentroid } from "../ctors/rect";
import { copyAttribs } from "../internal/copy-attribs";
import { dispatch } from "../internal/dispatch";
import { centroid } from "./centroid";
export const offset = defmulti(dispatch);
offset.addAll({
    [Type.CIRCLE]: ($, n) => new Circle(set2([], $.pos), Math.max($.r + n, 0)),
    [Type.LINE]: ({ points: [a, b], attribs }, n) => {
        const norm = normalCW([], a, b, n);
        return new Quad([
            add2([], a, norm),
            add2([], b, norm),
            sub2([], b, norm),
            sub2([], a, norm),
        ], Object.assign({}, attribs));
    },
    [Type.RECT]: ($, n) => rectFromCentroid(centroid($), max2(null, addN2([], $.size, n), ZERO2), copyAttribs($)),
});
